export default "https://cdn-static.gokick.com/assets/90becb6b185a352a9c07d0641a2a2a86ee77cb9a/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";